import React, { useState, useEffect } from 'react';
import { OneKlicksFileSDK } from '../../../../../SDK/OneKlicksFileSDK';

const FileDownload = ({ fileid, filename }) => {
    console.log('fileid:', fileid);
    console.log('filename:', filename);
    const [fileUrl, setFileUrl] = useState(null);
    const [error, setError] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchFileUrl = async () => {
            try {
                setLoading(true);
                const response = await OneKlicksFileSDK.getfile(fileid);
                console.log("FILE URL", response);
                setFileUrl(response.fileUrl);
            } catch (err) {
                setError('Failed to load file');
                console.error('Error loading file:', err);
            } finally {
                setLoading(false);
            }
        };

        if (fileid) {
            fetchFileUrl();
        }
    }, [fileid]);

    if (loading) {
        return <div className="form-group form-group-half">Loading...</div>;
    }

    if (error) {
        return <div className="form-group form-group-half text-danger">{error}</div>;
    }

    if (!fileUrl) {
        return <div className="form-group form-group-half">No file available</div>;
    }

    return (
        <div className="form-group form-group-half">
            <a
                href={fileUrl}
                target="_blank"
                rel="noopener noreferrer"
                className="dc-btn dc-btnactive form-control"
                style={{ color: '#fff' }}
            >
                {"Download File" || 'View File'}
            </a>
        </div>
    );
};

export default FileDownload;
